import { alpha, Theme, Components } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { toggleButtonClasses } from '@mui/material/ToggleButton';
import { gray, brand } from '../themePrimitives';
import { border } from './utils';

/* eslint-disable import/prefer-default-export */
export const inputsCustomizations: Components<Theme> = {
  MuiButtonBase: {
    defaultProps: {
      disableTouchRipple: false,
      disableRipple: false,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        boxSizing: 'border-box',
        transition: 'all 100ms ease-in',
        '&:focus-visible': {
          outline: `3px solid ${alpha(theme.palette.primary.main, 0.5)}`,
          outlineOffset: '2px',
        },
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightMedium,
        padding: '8px 16px',
        '&:hover': {
          boxShadow: theme.shadows[2],
        },
      }),
      contained: ({ theme }) => ({
        backgroundColor: gray[200],
        border: border(theme),
        color: theme.palette.primary.main,
        boxShadow: theme.shadows[2],
        '&:hover': {
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[4],
        },
        '&:active': {
          backgroundColor: theme.palette.background.default,
          boxShadow: theme.shadows[6],
        },
        '&.Mui-disabled': {
          backgroundColor: alpha(theme.palette.grey[50], 0.5),
          color: alpha(theme.palette.primary.contrastText, 0.5),
        },
        ...theme.applyStyles('dark', {
          backgroundColor: gray[900],
          color: brand[50],
          border: border(theme),
          '&:hover': {
            backgroundColor: gray[700],
            boxShadow: theme.shadows[2],
          },
          '&.Mui-disabled': {
            backgroundColor: alpha(gray[800], 0.1),
            color: alpha(brand[400], 0.5),
            border: 0
          },
          '&:active': {
            backgroundColor: gray[600],
          },
        }),
      }),
      containedSecondary: ({ theme }) => ({
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: theme.palette.secondary.dark,
        },
        '&:active': {
          backgroundColor: theme.palette.secondary.dark,
        },
        '&.Mui-disabled': {
          backgroundColor: alpha(theme.palette.secondary.main, 0.5),
          color: alpha(theme.palette.secondary.contrastText, 0.5),
        },
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.secondary.light,
          color: theme.palette.primary.contrastText,
          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
          },
          '&:active': {
            backgroundColor: theme.palette.secondary.dark,
          },
        }),
      }),
    },
  },

  MuiIconButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightMedium,
        letterSpacing: 0,
        backgroundColor: 'inherit',

        color: theme.palette.primary.main,
        //color: theme.palette.text.primary,
        //border: '1px solid ',
        //borderColor: gray[200],
        '&:hover': {
          //backgroundColor: gray[100],
          //borderColor: gray[300],
        },
        '&:active': {
          //backgroundColor: gray[200],
        },
        ...theme.applyStyles('dark', {
          // backgroundColor: gray[900],
          //backgroundColor: gray[800],
          //borderColor: gray[700],
          '&:hover': {
            //backgroundColor: gray[900],
            //borderColor: gray[600],
          },
          '&:active': {
            //backgroundColor: gray[900],
          },
        }),
        variants: [
          {
            props: {
              size: 'small',
            },
            style: {
              width: '2.25rem',
              height: '2.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' },
            },
          },
          {
            props: {
              size: 'medium',
            },
            style: {
              width: '2.5rem',
              height: '2.5rem',
            },
          },
        ],
      }),
    },
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: '10px',
        boxShadow: `0 4px 16px ${alpha(gray[400], 0.2)}`,
        [`& .${toggleButtonGroupClasses.selected}`]: {
          color: brand[500],
        },
        ...theme.applyStyles('dark', {
          [`& .${toggleButtonGroupClasses.selected}`]: {
            color: gray[50],
          },
          boxShadow: `0 4px 16px ${alpha(brand[700], 0.5)}`,
        }),
      }),
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: '12px 16px',
        textTransform: 'none',
        borderRadius: '10px',
        fontWeight: 500,
        ...theme.applyStyles('dark', {
          color: gray[400],
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.5)',
          [`&.${toggleButtonClasses.selected}`]: {
            color: brand[300],
          },
        }),
      }),
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: ({ theme }) => ({
        //margin: 10,
        //height: 16,
        //width: 16,
        //borderRadius: 5,
        //border: '1px solid ',
        //borderColor: alpha(gray[300], 0.8),
        //boxShadow: '0 0 0 1.5px hsla(210, 0%, 0%, 0.04) inset',
        //backgroundColor: alpha(gray[100], 0.4),
        //transition: 'border-color, background-color, 120ms ease-in',
        /*
        '&:hover': {
          borderColor: brand[300],
        },
        '&.Mui-focusVisible': {
          outline: `3px solid ${alpha(brand[500], 0.5)}`,
          outlineOffset: '2px',
          borderColor: brand[400],
        },
        '&.Mui-checked': {
          color: 'white',
          backgroundColor: brand[500],
          borderColor: brand[500],
          boxShadow: `none`,
          '&:hover': {
            backgroundColor: brand[600],
          },
        },
        ...theme.applyStyles('dark', {
          borderColor: alpha(gray[700], 0.8),
          boxShadow: '0 0 0 1.5px hsl(210, 0%, 0%) inset',
          backgroundColor: alpha(gray[900], 0.8),
          '&:hover': {
            borderColor: brand[300],
          },
          '&.Mui-focusVisible': {
            borderColor: brand[400],
            outline: `3px solid ${alpha(brand[500], 0.5)}`,
            outlineOffset: '2px',
          },
        }),
        */
      }),
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        border: 'none',
        //MODIFICA PER L'AUTOCOMPLETE DI GOOGLE
        "& input:-webkit-autofill": {
          WebkitBoxShadow: "0 0 0 1000px transparent inset",
          transition: "background-color 5000s ease-in-out 0s",
        },
      },
      input: {
        '&::placeholder': {
          opacity: 0.7,
          color: gray[500],
        },
      },
    },
  },
  MuiInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.Mui-error:before': {
          borderBottomColor: theme.palette.error.dark,
        },
        '&.Mui-error.Mui-focused:after': {
          borderBottomColor: theme.palette.error.dark,
        },
      }),
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: 0,
      },
      root: ({ theme }) => ({
        padding: 15,
        color: theme.palette.text.primary,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.default,
        transition: 'border 120ms ease-in',
        '&:hover': {
          borderColor: gray[400],
        },
        /*
        [`&.${outlinedInputClasses.focused}`]: {
          outline: `1px solid ${alpha(brand[500], 0.5)}`,
          borderColor: brand[400],
        },
        */
        ...theme.applyStyles('dark', {
          '&:hover': {
            borderColor: gray[500],
          },
        }),
      }),
      notchedOutline: {
        border: 'none',
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.grey[500],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[400],
        }),
      }),
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        typography: theme.typography.caption,
        marginBottom: 8,
        '&.Mui-error': {
          color: theme.palette.error.dark,
        },
      }),
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: ({ theme }) => ({
        marginLeft: 0,
        marginRight: 0,
        '&.Mui-error': {
          color: theme.palette.error.dark,
        },
      })
    }
  },
};
